import React, { useState } from 'react';
import { Layout, Dropdown, Spin } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import NavigationMenu from './NavigationMenu';
import UserProfile from '../Auth/UserProfile';
import { usePermissions } from '../../contexts/PermissionContext';

const { Header, Content } = Layout;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const { hasPermission, isLoading } = usePermissions();

  const showHeader = hasPermission('GCvsc.Menu.Read');

  const handleMenuVisibleChange = (visible: boolean) => {
    setMenuVisible(visible);
  };

  const closeMenu = () => {
    setMenuVisible(false);
  };

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: '16px' }}>
        <Spin size="large" />
        <p>Cargando permisos...</p>
      </div>
    );
  }

  // Sin header ni menú → modo presentación (usuarios sin GCvsc.Menu.Read)
  if (!showHeader) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Content style={{ margin: 0, padding: 0, minHeight: '100vh', background: '#fff' }}>
          {children}
        </Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        style={{
          padding: '0 24px',
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid #f0f0f0',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Dropdown
            dropdownRender={() => (
              <div
                style={{
                  background: '#fff',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                  borderRadius: '4px',
                  minWidth: '250px',
                }}
              >
                <div
                  style={{
                    padding: '16px',
                    borderBottom: '1px solid #f0f0f0',
                    fontWeight: 'bold',
                    fontSize: '16px',
                  }}
                >
                  GCvsc
                </div>
                <NavigationMenu onMenuClick={closeMenu} />
              </div>
            )}
            trigger={['click']}
            open={menuVisible}
            onOpenChange={handleMenuVisibleChange}
            placement="bottomLeft"
          >
            <MenuOutlined
              style={{ fontSize: '18px', cursor: 'pointer', marginRight: '24px' }}
            />
          </Dropdown>
          <span style={{ fontSize: '18px', fontWeight: 500 }}>
            Gescom
          </span>
        </div>
        <UserProfile />
      </Header>

      <Content
        style={{
          margin: '24px 16px',
          padding: 24,
          minHeight: 280,
          background: '#fff',
          borderRadius: '8px',
        }}
      >
        {children}
      </Content>
    </Layout>
  );
};

export default MainLayout;
